// extracted by mini-css-extract-plugin
module.exports = {"container":"auth_layout_container__KppuI","fullHeight":"auth_layout_fullHeight__sqIx1","content":"auth_layout_content__lqPGN","children":"auth_layout_children__u7i5j"};